<template>
	<PopupRouterView label="Purchase Order Status Input"  entityName="IncomingDocumentType" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" />
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import IncomingDocumentType from '@/models/IncomingDocumentType/IncomingDocumentType';
import IncomingDocumentTypeList from '@/models/IncomingDocumentType/IncomingDocumentTypeList';
import IncomingDocumentTypeFilter from '@/filters/IncomingDocumentType/IncomingDocumentTypeFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,PopupRouterView},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterIncomingDocumentType : null,
			currentIncomingDocumentTypePage : 1,
			incomingIncomingDocumentTypePageSize: 10,
			sortByIncomingDocumentType: '',
			sortDescIncomingDocumentType: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getIncomingDocumentType : async function(id) {
			this.isBusy = true;
			IncomingDocumentType.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadIncomingDocumentType = true;
			this.filterIncomingDocumentType.id = this.modelId;
			IncomingDocumentType.downloadDataDetail(this, this.filterIncomingDocumentType).then(result => {
				this.isDownloadIncomingDocumentType = false;
			}).catch(error => { this.isDownloadIncomingDocumentType = false; })
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					IncomingDocumentType.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'incomingdocumenttypeindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				} else {
					IncomingDocumentType.insertData(this, model).then(result => {
						this.$router.push({ name: 'incomingdocumenttypeindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			/*Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					IncomingDocumentType.updateData(this, model, id);
				}
			});*/
		},
		onHidden() {
			this.getIncomingDocumentTypes();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterIncomingDocumentType = new IncomingDocumentTypeFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getIncomingDocumentType(id);
			} else {
				this.modelId = id;
				this.getIncomingDocumentType(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			//IncomingDocumentType.discardData(this, this.modelId);
		}
	},
}
</script>
